module.exports = __webpack_public_path__ + "static/media/ePoint_blanco_color.fbf448c1.png";